import React, { Fragment } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'dva';
import {
  getOnChange,
  isNameChangedToggle,
  trimOnBlur,
} from '../../../helpers/handlers';
import NameChangeRadio from '../../shared/NameChangeRadio/NameChangeRadio';
import ChangeFIO from '../../shared/ChangeFIO/ChangeFIO';
import { SPOUSE } from '../../../constants/modelNames';
import { ADDRESS_MATCH } from '../../../constants/spouse';

function SpouseNameChange({ spouse, onChange, isNameChangedToggle, onBlur }) {
  const {
    changeName,
    address,
    addressMatchWithApplicant,
    isRegisteredInMoscow,
    ...ChangeFIOFields
  } = spouse;
  if (
    !(
      addressMatchWithApplicant.value === ADDRESS_MATCH.match ||
      address.isAddressCompleted ||
      !isRegisteredInMoscow
    )
  )
    return null;
  return (
    <Fragment>
      <NameChangeRadio
        model={SPOUSE}
        changeName={changeName}
        isNameChangedToggle={isNameChangedToggle}
      />
      <ChangeFIO
        changeName={changeName}
        onChange={onChange}
        onBlur={onBlur}
        {...ChangeFIOFields}
      />
    </Fragment>
  );
}

const mapStateToProps = ({ spouse }) => ({ spouse });
const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: getOnChange(SPOUSE, dispatch),
  onBlur(event) {
    trimOnBlur(SPOUSE, dispatch)(event);
    dispatch({ type: 'form/saveDraft' });
  },
  isNameChangedToggle: isNameChangedToggle(SPOUSE, dispatch),
});

const SpouseNameChangeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpouseNameChange);

export { SpouseNameChangeContainer as SpouseNameChange };
